var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('video-player',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"videoPlayer",staticClass:"video-player",attrs:{"element-loading-background":"rgb(0,0,0)","playsinline":true,"options":_vm.playerOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }